export interface UtilityVendor {
    id: string;
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
    name: string;
    description: string;
    url: string;
    metadata: string;
    type: string;
}

export type LastConnectionStatus =
    | "success"
    | "connection_failed"
    | "attention_needed"
    | "warning"
    | null;

export interface RemoteCredential {
    id: string;
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
    customer_id: string;
    customer_name: string;
    name: string;
    user_name: string;
    password: string;
    url: string;
    notes: string;
    vendor_id: string | null;
    vendor?: UtilityVendor;
    last_connection_at: string | null;
    last_connection_status: LastConnectionStatus | null;
    two_fa_phone?: string | null;
    two_fa_method?: string | null;
    automation_enabled?: boolean;
    type?: string | null;
    system_name?: string | null;
    bank_institution_name?: string | null;
    routing_number?: string | null;
    updated_by?: string | null;
    created_by?: string | null;
}

export interface Credential {
    id: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
    customerId: string;
    customerName: string;
    name: string;
    userName: string;
    password: string;
    url: string;
    notes: string;
    vendorId: string | null;
    vendor?: UtilityVendor;
    lastConnectionAt: string | null;
    lastConnectionStatus: LastConnectionStatus | null;
    twoFaPhone?: string | null;
    twoFaMethod?: string | null;
    automationEnabled?: boolean;
    type?: string | null;
    systemName?: string | null;
    bankInstitutionName?: string | null;
    routingNumber?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
}

export interface UpdateCredentialPayload {
    id?: string;
    customer_id: string;
    customer_name: string;
    name: string;
    user_name: string;
    password?: string;
    url: string;
    notes: string;
    vendor_id?: string | null;
    two_fa_phone?: string | null;
    two_fa_method?: string | null;
    automation_enabled?: boolean;
    type?: string | null;
    system_name?: string | null;
    bank_institution_name?: string | null;
    routing_number?: string | null;
    updated_by?: string | null;
}

export interface CreateCredentialPayload {
    customer_id: string;
    customer_name: string;
    name: string;
    user_name: string;
    password?: string;
    url: string;
    notes: string;
    vendor_id?: string | null;
    two_fa_phone?: string | null;
    two_fa_method?: string | null;
    automation_enabled?: boolean;
    type?: string | null;
    system_name?: string | null;
    bank_institution_name?: string | null;
    routing_number?: string | null;
    created_by?: string | null;
}

export function remoteCredentialToLocal(remote: RemoteCredential): Credential {
    return {
        id: remote.id,
        createdAt: remote.created_at,
        updatedAt: remote.updated_at,
        deletedAt: remote.deleted_at,
        customerId: remote.customer_id,
        customerName: remote.customer_name,
        name: remote.name,
        userName: remote.user_name,
        password: remote.password,
        url: remote.url,
        notes: remote.notes,
        vendorId: remote.vendor_id,
        vendor: remote.vendor,
        lastConnectionAt: remote.last_connection_at,
        lastConnectionStatus: remote.last_connection_status,
        twoFaPhone: remote.two_fa_phone,
        twoFaMethod: remote.two_fa_method,
        automationEnabled: remote.automation_enabled,
        type: remote.type,
        systemName: remote.system_name,
        bankInstitutionName: remote.bank_institution_name,
        routingNumber: remote.routing_number,
        updatedBy: remote.updated_by,
        createdBy: remote.created_by,
    };
}
